import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 机构管理数据
    getmechanism({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Organize/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存岗位管理数据
    savemechanism({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Organize/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备属性
    Deletemechanism({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Organize/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取类型下拉数据
    gettypelist({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
